// A rental property's files are Media rows, written through beleef-backend's
// /admin/media endpoints (controllers/admin/media.js there) rather than the
// PrepareMarketing arrays. See utils/mediaEditorView.js for how the editor
// reads the rows. Kept in step with beleef-services-frontend's apis/media.js.
import api from "../utils/axios";

const unwrap = (res) => {
  if (!res.data?.success) throw new Error(res.data?.message || "Request failed");
  return res.data;
};

export const mediaApi = {
  uploadRaw: (propertyId, body) =>
    api.post(`/admin/media/property/${propertyId}/raw`, body).then(unwrap),
  deliver: (propertyId, body) =>
    api.post(`/admin/media/property/${propertyId}/delivery`, body).then(unwrap),
  setStatus: (propertyId, body) =>
    api.post(`/admin/media/property/${propertyId}/status`, body).then(unwrap),
  deliverFloorplan: (propertyId, body) =>
    api.post(`/admin/media/property/${propertyId}/floorplan`, body).then(unwrap),
  saveVideo: (propertyId, body) =>
    api.post(`/admin/media/property/${propertyId}/video`, body).then(unwrap),
  reviewVideo: (propertyId, body) =>
    api.post(`/admin/media/property/${propertyId}/video/review`, body).then(unwrap),
  remove: (mediaId) => api.delete(`/admin/media/${mediaId}`).then(unwrap),
};

/**
 * Edited photos, in the editedWebPhotos/editedPrintPhotos form the editor
 * builds (web and print sharing a capture number), delivered as captures of
 * the Media rows that number names — `view` is the page's editorViewOf().
 * A capture with no row yet is created with the id newCaptureId() gave it.
 */
export async function deliverEditedPhotos({
  view,
  propertyId,
  eventId,
  editedWebPhotos = [],
  editedPrintPhotos = [],
  persistOnly = false,
  completeEvent = false,
}) {
  const pairs = new Map();
  const pairOf = (id) => {
    const key = Number(id);
    if (!pairs.has(key)) pairs.set(key, {});
    return pairs.get(key);
  };
  editedWebPhotos.forEach((photo) => (pairOf(photo.id).web = photo));
  editedPrintPhotos.forEach((photo) => (pairOf(photo.id).print = photo));

  const file = (photo) =>
    photo?.s3Key || photo?.url
      ? { s3Key: photo.s3Key, url: photo.url, name: photo.name, size: photo.size }
      : undefined;
  const captures = [...pairs.entries()].map(([number, { web, print }]) => ({
    key: String(number),
    mediaId: view?.__media?.webIdOf(number) || undefined,
    sourceId: web?.rawPhotoImageId || undefined,
    category: web?.category || print?.category || undefined,
    webCropRect: web?.webCropRect ?? print?.webCropRect,
    web: file(web),
    print: file(print),
  }));

  return mediaApi.deliver(propertyId, {
    eventId: eventId || editedWebPhotos[0]?.eventId || editedPrintPhotos[0]?.eventId,
    persistOnly,
    completeEvent,
    captures,
  });
}
